<template>
    <div>
        <delete-i-b-modal v-if="showModal"
            :order="order"
            @confirm="onIntermediaryBusinessDeletion"
            @cancel="showModal = false">
        </delete-i-b-modal>
        
        <div v-if="!forms.association">
            {{ intermediaryBusinessName }}

            <div v-if="!order.cancelled">
                <button v-if="hasIntermediaryBusiness && ('intermediary_business' != order.payer || order.payable)"
                    class="btn btn-default btn-sm ib-association-button"
                    @click="showModal = true"
                    :disabled="requestInProgress"
                >
                    Supprimer
                </button>

                <button v-else-if="!hasIntermediaryBusiness"
                    @click="forms.association = true"
                    class="btn btn-default btn-sm ib-association-button"
                    :disabled="requestInProgress"
                >
                    Associer
                </button>
            </div>
        </div>
        
        <div v-else>
            <div class="form-group">
                <label>Recherchez un apporteur d'affaires</label>

                <search-and-select :initial-value="selectedIntermediaryBusiness"
                    :search-config="intermediaryBusinessSearchConfig"
                    :get-option-label="getIntermediaryBusinessSearchLabel"
                    :min-chars="3"
                    @field-updated="updateIntermediaryBusiness">
                </search-and-select>
            </div>
            <div class="buttons-container">
                <button v-if="selectedIntermediaryBusiness"
                    class="btn btn-sm"
                    @click="onAssociation"
                    :disabled="requestInProgress"
                >
                    Associer
                </button>

                <button class="btn btn-sm btn-danger"
                    @click="onCancelAssociation"
                    :disabled="requestInProgress"
                >
                    Annuler
                </button>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.ib-association-button {
    margin-left: 10px;
}

.buttons-container {
    margin-top: 10px;

    .btn {
        margin-right: 5px;

        &:last-child {
            margin-right: 0;
        }
    }
}
</style>

<script type="text/babel">
    import { mapState, mapActions, mapGetters } from 'vuex'
    import DeleteIBModal from './DeleteIBModal'
    import SearchAndSelect from "components/Forms/Elements/SearchAndSelect"

    import searchMixin from 'mixins/search'

    export default {
        components: {
            DeleteIBModal,
            SearchAndSelect
        },

        mixins: [searchMixin],

        data () {
            return {
                showModal: false,
                forms: {
                    association: false
                },
                selectedIntermediaryBusiness: null,
                requestInProgress: false
            }
        },

        props: ['order'],

        computed: {
            intermediaryBusiness() {
                return this.order.intermediary_business
            },

            hasIntermediaryBusiness() {
                return !_.isNil(this.intermediaryBusiness) ? true : false
            },

            intermediaryBusinessName() {
                let name = ''
                
                if ( this.hasIntermediaryBusiness ) {
                    name = this.intermediaryBusiness.name

                    if ( this.intermediaryBusiness.erp_id )
                        name += ' (' + this.intermediaryBusiness.erp_id + ')'
                } else {
                    name = 'Aucun'
                }

                return name
            },
        },

        methods: {
            ...mapActions("customer", ['fetchOrders']),

            resetFields() {
                this.selectedIntermediaryBusiness = null
            },

            removeIntermediaryBusiness()
            {
                return (this.axios.delete(`orders/${this.order.id}/intermediary_business`)
                .then((response) => {
                    this.fetchOrders()
                })
            )},

            addIntermediaryBusiness(model)
            {
                const data = { intermediary_business_id: model.id }

                return (this.axios.post(`orders/${this.order.id}/intermediary_business`, data)
                .then((response) => {
                    this.fetchOrders()
                })
            )},

            updateIntermediaryBusiness(event)
            {
                this.selectedIntermediaryBusiness = event
            },

            onAssociation() {
                this.requestInProgress = true

                this.addIntermediaryBusiness(this.selectedIntermediaryBusiness)
                    .then(() => {
                        this.onCancelAssociation()
                        this.requestInProgress = false
                    })
            },

            onCancelAssociation() {
                this.resetFields()
                this.forms.association = false
            },

            onIntermediaryBusinessDeletion() {
                this.requestInProgress = true

                this.removeIntermediaryBusiness()
                    .then(() => {
                        this.showModal = false
                        this.requestInProgress = false
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// client/components/Customer/OrdersTabContent/OrderIntermediaryBusiness.vue